<template>
    <div>
		<img src="../assets/img/detail/sjg/1.jpg" width="100%" />
		<img src="../assets/img/detail/sjg/2.jpg" width="100%"/>
		<img src="../assets/img/detail/sjg/3.jpg" width="100%"/>
		<img src="../assets/img/detail/sjg/4.jpg" width="100%"/>
		<img src="../assets/img/detail/sjg/5.jpg" width="100%"/>
		<img src="../assets/img/detail/sjg/6.jpg" width="100%"/>
		<img src="../assets/img/detail/sjg/7.jpg" width="100%"/>
		<img src="../assets/img/detail/sjg/8.jpg" width="100%"/>
		<img src="../assets/img/detail/sjg/9.jpg" width="100%"/>
		<img src="../assets/img/detail/sjg/10.jpg" width="100%"/>
		<img src="../assets/img/detail/sjg/11.jpg" width="100%"/>
    </div>
</template>

<script>
    export default {
        name: 'Product_sswm',
        data: function () {
            return {
            }
        },
        mounted: function () {

        },
        created: function () {

        },
        methods: {

        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>